import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { archiveQuestion } from ".";

export function useArchiveQuestion(){
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: queryKeys.question._def,
        mutationFn: archiveQuestion,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.question._def, exact: false });
        }
    });
}
